<template>
  <div>
    <div class="card">
      <div class="card-top">
        <span></span>
        <h3>公司信息维护</h3>
      </div>
      <el-tabs v-model="activeName">
        <div class="tab">
          <el-form ref="ruleForm" :model="formData" label-width="100px">
            <el-form-item label="客服QQ：">
              <el-input v-model="formData.conmpanyQq1" placeholder="客服QQ1"></el-input>
              <el-input v-model="formData.conmpanyQq2" placeholder="客服QQ2"></el-input>
              <el-input v-model="formData.conmpanyQq3" placeholder="客服QQ3"></el-input>
            </el-form-item>

            <el-form-item label="公司简介：">
              <editor
                  ref="editorOne"
                  v-model.trim="formData.conmpanyProfileContext"
                  :info="formData.conmpanyProfileContext"
                  style="width: 100%"
              ></editor>
            </el-form-item>
            <!--联系我们-->
            <el-form-item label="联系我们：">
              <editor
                  ref="editorOne"
                  style="width: 100%"
                  v-model.trim="formData.aboutUsContent"
                  :info="formData.aboutUsContent"
              ></editor>
            </el-form-item>

            <el-form-item label="法律申明：">
              <editor
                  ref="editorOne"
                  v-model.trim="formData.lawContent"
                  style="width: 100%"
                  :info="formData.lawContent"
              ></editor>
            </el-form-item>

            <!--转账信息-->
            <el-form-item label="转账信息：">
              <editor
                  ref="editorOne"
                  style="width: 100%"
                  v-model.trim="formData.mallBankInfo"
                  :info="formData.mallBankInfo"
              ></editor>
            </el-form-item>

            <!--预约自提-->
            <el-form-item label="预约自提：">
              <editor
                  ref="editorOne"
                  style="width: 100%"
                  v-model.trim="formData.pickUpContext"
                  :info="formData.pickUpContext"
              ></editor>
            </el-form-item>

            <!--送货上门-->
            <el-form-item label="送货上门：">
              <editor
                  ref="editorOne"
                  style="width: 100%"
                  v-model.trim="formData.provideHomeDeliveryContext"
                  :info="formData.provideHomeDeliveryContext"
              ></editor>
            </el-form-item>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button @click="cancle">取 消</el-button>
            <el-button type="primary" @click="sureAdd">确 定</el-button>
          </div>

        </div>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import api from "../../api/webAdmin/webAdmin";
import Editor from "../../components/wangeditor/index";

export default {
  name: "informationManage",
  components: {Editor},
  data() {
    return {
      activeName: '1',

      imageUrl1: "",

      //公司信息
      formData: {
        id: "",
        conmpanyProfileContext: "", //公司简介
        aboutUsContent: "",
        conmpanyQq1: '',//QQ1
        conmpanyQq2: '',//QQ2
        conmpanyQq3: '',//QQ3
        mallBankInfo: "",
        lawContent: "",
        pickUpContext: "",
        provideHomeDeliveryContext: "",
      },

    };
  },
  created() {
    this.init();
  },
  methods: {

    // 清空表单
    clearFrom() {
      this.formData.conmpanyProfileContext = this.formData.conmpanyProfileContext
      this.formData.aboutUsContent = this.formData.aboutUsContent
      this.formData.conmpanyQq1 = this.formData.conmpanyQq1
      this.formData.conmpanyQq2 = this.formData.conmpanyQq2
      this.formData.conmpanyQq3 = this.formData.conmpanyQq3
      this.formData.mallBankInfo = this.formData.mallBankInfo
      this.formData.lawContent = this.formData.lawContent
      this.formData.pickUpContext = this.formData.pickUpContext
      this.formData.provideHomeDeliveryContext = this.formData.provideHomeDeliveryContext

    },
    //取消
    cancle() {
      this.clearFrom();
    },
    // 新增
    sureAdd() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if(this.formData.id){
            this.$http.put("/companyprofile/"+this.formData.id, this.formData).then((res) => {
              console.log("新增公司信息", res);
              if (res.data.code == 200) {
                this.$message.success("修改成功");
                this.clearFrom();
                this.init();
              } else {
                this.$message.error("修改失败");

              }
            })
          } else {
            this.$http.post("/companyprofile", this.formData).then((res) => {
              console.log("新增公司信息", res);
              if (res.data.code == 200) {
                this.$message.success("新增成功");
                this.init();
              } else {
                this.$message.error("新增失败");

              }
            })
          }

        } else {
          this.$message.error("请认真填写带*的内容");
          return false;
        }
      });
    },
    //公司简介新增


    //获取公司简介列表
    init() {
      this.$http.get("/companyprofile/listAll").then((res) => {
        console.log("获取公司简介列表", res);
        if (res.data.code == 200) {
          this.formData.id = res.data.data[0].id
          this.formData.conmpanyProfileContext = res.data.data[0].conmpanyProfileContext
          this.formData.aboutUsContent = res.data.data[0].aboutUsContent
          this.formData.conmpanyQq1 = res.data.data[0].conmpanyQq1
          this.formData.conmpanyQq2 = res.data.data[0].conmpanyQq2
          this.formData.conmpanyQq3 = res.data.data[0].conmpanyQq3
          this.formData.mallBankInfo = res.data.data[0].mallBankInfo
          this.formData.lawContent = res.data.data[0].lawContent
          this.formData.pickUpContext = res.data.data[0].pickUpContext
          this.formData.provideHomeDeliveryContext = res.data.data[0].provideHomeDeliveryContext

        } else {
          this.$message.error("查询失败");
        }
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/*富文本高度*/
.w-e-text-container {
  height: 140px !important;
}

.w-e-toolbar .w-e-menu {
  width: 30px !important;
  height: 30px !important;
}

.fwb {
  .el-form-item__content > div {
    width: 100% !important;
  }
}

.el-form-item__content {
  /*#wangEditor-1,#wangEditor-2,#wangEditor-3{*/
  /*    width: 100% !important;*/
  /*}*/
  #wangEditor-2 {
    width: 100% !important;
  }

  #wangEditor-3 {
    width: 100% !important;
  }
}


/*客服QQ*/
.el-form-item__content {
  display: flex;
  /*justify-content: space-between;*/
  .el-input {
    width: auto;
    /*margin-right: 24px;*/
  }
}
</style>
<style lang="scss" scoped>
.card {
  width: 100%;

  .card-top {
    display: flex;
    align-items: center;
    height: 50px;
    border-bottom: 1px solid #e6e6e6;
    padding: 0 30px;
    line-height: 50px;

    span {
      display: inline-block;
      width: 5px;
      height: 17px;
      background: #058af2;
      margin-right: 20px;
    }

    h3 {
      color: #058af2;
    }
  }

  .tab {
    padding: 10px;

    .tap {
      margin-bottom: 10px;
    }
  }

  .page {
    margin-top: 20px;
  }
}
</style>
